(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Menú móvil */
  var toggle = $('[data-menu-toggle]');
  if (toggle) {
    var setMenu = function (open) {
      document.body.classList.toggle('nav-open', open);
      toggle.setAttribute('aria-expanded', open);
    };
    toggle.addEventListener('click', function () { setMenu(!document.body.classList.contains('nav-open')); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
    document.addEventListener('click', function (e) {
      if (document.body.classList.contains('nav-open') && !e.target.closest('[data-nav]') && !e.target.closest('[data-menu-toggle]')) setMenu(false);
    });
  }

  /* Cantidades */
  var debounce = function (fn, t) { var id; return function () { clearTimeout(id); id = setTimeout(fn, t); }; };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus],[data-qty-plus]');
    if (!btn) return;
    var input = $('input', btn.closest('.qty'));
    var min = input.getAttribute('min') === '0' ? 0 : 1;
    var v = parseInt(input.value, 10) || min;
    input.value = Math.max(min, v + (btn.hasAttribute('data-qty-plus') ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  $$('[data-autosubmit-input]').forEach(function (input) {
    var form = input.form;
    input.addEventListener('change', debounce(function () {
      var u = document.createElement('input'); u.type = 'hidden'; u.name = 'update'; u.value = '1';
      form.appendChild(u); form.submit();
    }, 600));
  });

  /* Filtros de colección */
  $$('[data-autosubmit]').forEach(function (f) {
    f.addEventListener('change', function () { f.submit(); });
  });

  /* Contador del carrito */
  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
      });
  }

  /* Ficha de producto */
  $$('[data-product]').forEach(function (el) {
    var variants = JSON.parse($('[data-variants]', el).textContent);
    var form = $('form', el);
    var idInput = $('[data-variant-id]', el);
    var addBtns = $$('[data-add],[data-add-sticky]', el);
    var label = $('[data-add-label]', el);
    var stockEl = $('[data-stock]', el);
    var low = parseInt(el.dataset.lowStock, 10) || 0;
    var fmt = new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: el.dataset.currency });
    var money = function (c) { return fmt.format(c / 100); };

     function showMedia(id) {
  if (!id) return;

  var selectedSlide = null;

  $$('.gallery__slide', el).forEach(function (s) {
    var selected = s.dataset.mediaId == id;
    s.classList.toggle('is-active', selected);
    if (selected) selectedSlide = s;
  });

  $$('[data-thumb]', el).forEach(function (t) {
    t.classList.toggle('is-active', t.dataset.thumb == id);
  });

  if (selectedSlide && window.matchMedia('(max-width: 899px)').matches) {
    var gallery = $('.gallery__main', el);

    if (gallery) {
      var distance =
        selectedSlide.getBoundingClientRect().left -
        gallery.getBoundingClientRect().left -
        gallery.clientLeft;

      gallery.scrollTo({
        left: gallery.scrollLeft + distance,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth'
      });
    }
  }
}
    $$('[data-thumb]', el).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumb); }); });

    function setStock(v) {
      if (!stockEl) return;
      if (v && v.available && low > 0 && v.qty !== null && v.qty > 0 && v.qty <= low) {
        stockEl.textContent = 'Últimas ' + v.qty + ' unidades';
        stockEl.hidden = false;
      } else { stockEl.hidden = true; }
    }
    setStock(variants.find(function (v) { return v.id == idInput.value; }));

    function update() {
      var sel = $$('[data-option]', el).map(function (f) {
        var c = $('input:checked', f);
        $('[data-option-label]', f).textContent = c ? c.value : '';
        return c ? c.value : null;
      });
      var v = variants.find(function (x) { return sel.every(function (val, i) { return x.options[i] === val; }); });
      addBtns.forEach(function (b) {
        b.disabled = !v || !v.available;
        if (b.hasAttribute('data-add-sticky')) b.textContent = !v ? 'No disponible' : (v.available ? 'Añadir' : 'Agotado');
      });
      if (label) label.textContent = !v ? 'No disponible' : (v.available ? 'Añadir al carrito' : 'Agotado');
      if (!v) { setStock(null); return; }
      idInput.value = v.id;
      $('[data-price]', el).textContent = money(v.price);
      var sticky = $('[data-price-sticky]', el); if (sticky) sticky.textContent = money(v.price);
      var onSale = v.compare > v.price;
      var cmp = $('[data-compare]', el), sav = $('[data-saving]', el);
      cmp.hidden = sav.hidden = !onSale;
      if (onSale) { cmp.textContent = money(v.compare); sav.textContent = '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%'; }
      setStock(v);
      showMedia(v.media);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
    $$('[data-option] input', el).forEach(function (i) { i.addEventListener('change', update); });

    /* Añadir y llevar al carrito */
    form.addEventListener('submit', function (e) {
      if (!window.fetch || (e.submitter && e.submitter.name !== 'add')) return;
      e.preventDefault();
      var redirecting = false;
      addBtns.forEach(function (b) { b.disabled = true; });
      fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { alert(res.d.description || 'No se pudo añadir el producto.'); return; }
          redirecting = true;
          if (label) label.textContent = 'Añadido';
          window.location.href = root + 'cart';
        })
        .catch(function () { redirecting = true; form.submit(); })
        .then(function () { if (!redirecting) addBtns.forEach(function (b) { b.disabled = false; }); });
    });

    /* Barra fija en móvil */
    var bar = $('[data-sticky-buy]', el), mainBtn = $('[data-add]', el);
    if (bar && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(mainBtn);
    }
  });
})();
